import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_SUBSCRIPTION,
    UPDATE_SUBSCRIPTION,
    CREATE_SUBSCRIPTION, DELETE_SUBSCRIPTION
} from 'constants/subscriptions.constants'
import axios from 'axios'
import {
    fetchSubscriptionsSuccess,
    updateSubscriptionSuccess,
    createSubscriptionSuccess,
    deleteSubscriptionSuccess
} from "actions/subscriptions.action";
import { showErrors, stopLoader } from "actions/general.action";


// subscription sagas

const fetchSubscriptionsRequest = async (page) => {
    return axios.get('/api/v1/super_admin/subscriptions');
}

function* fetchSubscriptions({ payload }) {
    try {
        const reuslt = yield call(fetchSubscriptionsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchSubscriptionsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateSubscriptionsRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.subscription_type_id}
    o.country = {id: payload.country_id}

    return axios.put('/api/v1/super_admin/subscriptions/' + payload.id,
        o
    );
}

function* updateSubscription({ payload }) {
    try {
        const reuslt = yield call(updateSubscriptionsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateSubscriptionSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createSubscriptionsRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.partner_type = {id: payload.subscription_type_id}
    o.country = {id: payload.country_id}

    return axios.post('/api/v1/super_admin/subscriptions',
        o
    );
}

function* createSubscription({ payload }) {
    try {
        const reuslt = yield call(createSubscriptionsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createSubscriptionSuccess(reuslt.data)),
                //put(stopLoader("Subscription created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deleteSubscriptionsRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/subscriptions/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteSubscription({ payload }) {
    try {
        const reuslt = yield call(deleteSubscriptionsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteSubscriptionSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}


// fork subscription
export function* forkFetchSubscriptions() {
    yield takeEvery(FETCH_ALL_SUBSCRIPTION, fetchSubscriptions);
}

export function* forkUpdateSubscription() {
    yield takeEvery(UPDATE_SUBSCRIPTION, updateSubscription);
}

export function* forkCreateSubscription() {
    yield takeEvery(CREATE_SUBSCRIPTION, createSubscription);
}

export function* forkDeleteSubscription() {
    yield takeEvery(DELETE_SUBSCRIPTION, deleteSubscription);
}


export default function* rootSaga() {
    yield all([
        fork(forkFetchSubscriptions),
        fork(forkUpdateSubscription),
        fork(forkCreateSubscription),
        fork(forkDeleteSubscription),
    ]);
}